import { render, staticRenderFns } from "./GameTypeFilter.vue?vue&type=template&id=69076d39&scoped=true&"
import script from "./GameTypeFilter.vue?vue&type=script&lang=ts&"
export * from "./GameTypeFilter.vue?vue&type=script&lang=ts&"
import style0 from "./GameTypeFilter.vue?vue&type=style&index=0&id=69076d39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69076d39",
  null
  
)

export default component.exports